var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template"},[_c('h1',[_vm._v("Todo List")]),_c('TodoListInput',{on:{"receiveTask":_vm.onTaskAdd}}),_c('TodoListTasks',{attrs:{"task-list":_vm.taskList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }